const modals = {
  data() {
    return {
      modalContainer: null,
      cls: null,
    };
  },
  props: ['overlay'],
  mounted() {
    this.modalContainer = document.getElementById('drzModal-container');
    this.cls = '.editorUi-modalOverlay';
  },
  methods: {
    modelMoveOut(content) {
      let modal;
      if (this.cls.startsWith('#')) {
        modal = document.getElementById(this.cls.replace(/^#/, ''));
      } else {
        modal = content.querySelectorAll(this.cls)[0];
      }
      if (modal) {
        this.modalContainer.appendChild(modal);
        this.$store.dispatch('setGlobalOpenModal', true);
      }
    },
    modalMoveIn(parent) {
      let content;
      if (this.cls.startsWith('#')) {
        content = document.getElementById(this.cls.replace(/^#/, ''));
      } else {
        content = this.modalContainer.querySelectorAll(this.cls)[0];
      }
      // delay so we let the vue transition animation finish
      setTimeout(() => {
        parent.appendChild(content);
        this.$store.dispatch('setGlobalOpenModal', false);
      }, 250);
    },
  },
};

module.exports = { modals };



// WEBPACK FOOTER //
// ./src/mixins/modal.js